module.exports = __webpack_public_path__ + "img/logo.d04c8ca0.png";